/* Charmies package configurator. Isolated on purpose — it never touches the main Build-Your-Bundle
 * or checkout. Reuses the SAME charm data + picker design (type → colour image-swatch → scent) and
 * bills ONE fixed-price package line via CharmiesCart.addBundle: each chosen charm is recorded as a
 * line property (+ _charms so charm stock decrements, same as the bundle), plus the phone model and
 * "+ Mirror" via extraProps. Config comes from window.CHARMIES_PACKAGE (emitted per package). */
(function () {
  'use strict';
  var PKG = window.CHARMIES_PACKAGE;
  var root = document.getElementById('charmies-pdp');
  var controls = root && root.querySelector('[data-pkg-controls]');
  if (!PKG || !root || !controls || !window.CharmiesCart) return;

  var isAr = ((window.CHARMIES || {}).locale === 'ar');
  var money = CharmiesCart.money || function (n) { return isAr ? Number(n).toFixed(2) + ' QAR' : 'QAR ' + Number(n).toFixed(2); };
  var SCENTS = window.CHARMIES_SCENTS || [];
  var CHECK = '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var CHEV_UP = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>';
  var CHEV_DOWN = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
  var AR_D = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

  function L(en, ar) { var b = window.charmiesT; return (b && b[en] != null) ? b[en] : (isAr ? ar : en); }
  function arabicNum(n) { return String(n).split('').map(function (d) { return AR_D[+d] != null ? AR_D[+d] : d; }).join(''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function err(m) { if (CharmiesCart.toastError) CharmiesCart.toastError(m); else alert(m); }
  function colorEntry(n) { var s = (n || '').trim().toLowerCase(); return (window.CHARMIES_COLORS || []).find(function (c) { return c.en.toLowerCase() === s || c.ar === n; }); }
  function colorAr(n) { var e = colorEntry(n); return e ? e.ar : n; }
  function colorEnOf(n) { var e = colorEntry(n); return e ? e.en : n; }
  function colorHex(n) { var e = colorEntry(n); return e ? e.hex : null; }

  var SOURCES = (window.CHARMIES_BUNDLE_SOURCES || []).filter(function (s) { return s.colors.some(function (c) { return !c.oos; }); });
  function sourceByHandle(h) { return SOURCES.find(function (s) { return s.handle === h; }); }
  function typeName(handle) { var s = sourceByHandle(handle); var nm = (s && s.name) || handle; return { en: nm, ar: nm }; }
  function scentById(id) { return SCENTS.find(function (s) { return s.id === id; }); }
  function colorIn(src, name) { return src ? src.colors.find(function (c) { return c.name === name; }) : null; }
  function findVariant(src, colorEn, scentEn) {
    if (!src) return null;
    var c = (colorEn || '').trim().toLowerCase(), s = (scentEn || '').trim().toLowerCase();
    return src.variants.find(function (v) { return (v.color || '').trim().toLowerCase() === c && (v.scent || '').trim().toLowerCase() === s; }) || null;
  }
  function thumbForSource(src) {
    var pick = src.colors.find(function (c) { return /black|أسود/i.test(c.name); }) || src.colors.find(function (c) { return !c.oos; }) || src.colors[0];
    return (pick && pick.image) || src.images[0] || '';
  }
  function slotImage(slot) {
    var src = slot.handle ? sourceByHandle(slot.handle) : null;
    if (!src) return '';
    var col = colorIn(src, slot.color);
    return (col && col.image) || src.images[0] || '';
  }

  // Preset packages: each slot is locked to a fixed charm type — buyer only picks colour + scent.
  var PRESET = (PKG.presetHandles && PKG.presetHandles.length) ? PKG.presetHandles.filter(sourceByHandle) : null;
  if (PRESET && !PRESET.length) PRESET = null;
  var NCHARMS = PRESET ? PRESET.length : (PKG.charmSlots || 1);
  var MODELS = PKG.caseModels || [];
  var state = { model: PKG.includeCase ? (MODELS[0] || '') : null, slots: [], active: 0 };
  for (var si = 0; si < NCHARMS; si++) state.slots.push({ handle: PRESET ? PRESET[si] : '', color: '', scent: '' });

  function slotDone(s) { return !!(s.handle && s.color && s.scent); }
  function isComplete() { return (!PKG.includeCase || !!state.model) && state.slots.every(slotDone); }

  function render() {
    var html = '';

    // What's in the set
    var incl = [];
    if (PKG.includeCase) incl.push(L('Croc case', 'كفر الكروك'));
    if (PKG.includeMirror) incl.push(L('Phone Mirror', 'مرآة الجوال'));
    if (PRESET) { PRESET.forEach(function (h) { incl.push(isAr ? typeName(h).ar : typeName(h).en); }); }
    else incl.push((isAr ? arabicNum(NCHARMS) : NCHARMS) + ' ' + (NCHARMS > 1 ? L('charms', 'تشارميز') : L('charm', 'تشارمي')));
    html += '<div class="mb-6 rounded-2xl bg-blush/50 p-3 text-center text-sm ring-1 ring-rose-soft/40"><span class="font-semibold text-primary">' + L('Your set', 'باقتك') + ':</span> ' + esc(incl.join(' + ')) + '</div>';

    // Phone model (only if the package includes the case)
    if (PKG.includeCase) {
      html += '<div class="mb-6"><div class="mb-2 text-sm font-semibold text-primary">' + L('Choose your iPhone', 'اختاري جوالك') + '</div><div class="flex flex-wrap gap-2">';
      MODELS.forEach(function (m) {
        var on = state.model === m;
        html += '<button type="button" data-pkg-model="' + esc(m) + '" class="rounded-full border-2 px-4 py-2 text-sm font-medium transition ' + (on ? 'border-primary bg-primary/5 text-primary' : 'border-border text-muted-foreground hover:border-primary/40') + '">' + esc(m) + '</button>';
      });
      html += '</div></div>';
    }

    // Charm slots (accordion)
    state.slots.forEach(function (slot, i) {
      var open = state.active === i;
      var src = sourceByHandle(slot.handle);
      var col = colorIn(src, slot.color);
      var sc = scentById(slot.scent);
      var done = slotDone(slot);
      var img = slotImage(slot);
      html += '<div class="mb-3 rounded-2xl border bg-card ' + (done ? 'border-border' : 'border-primary/40') + '">';
      html += '<button type="button" data-pkg-toggle="' + i + '" class="flex w-full items-center justify-between gap-3 p-3"><div class="flex items-center gap-3">' +
        (img
          ? '<img src="' + esc(img) + '" alt="" class="h-11 w-11 rounded-full object-cover">'
          : '<div class="grid h-11 w-11 place-items-center rounded-full text-xs font-bold ' + (done ? 'text-white' : 'bg-primary text-primary-foreground') + '"' + (done ? ' style="background:#16a34a"' : '') + '>' + (done ? CHECK : (isAr ? arabicNum(i + 1) : (i + 1))) + '</div>') +
        '<div class="text-start text-sm"><div class="font-semibold">' + (PRESET ? esc(isAr ? typeName(slot.handle).ar : typeName(slot.handle).en) : (L('Charm', 'تشارمي') + ' ' + (isAr ? arabicNum(i + 1) : (i + 1)))) + '</div>' +
        (done
          ? '<div class="text-xs text-muted-foreground">' + esc((PRESET ? '' : (isAr ? typeName(slot.handle).ar : typeName(slot.handle).en) + ' · ') + (isAr ? colorAr(col.name) : col.name) + ' · ' + (isAr ? sc.ar : sc.en)) + '</div>'
          : '<div class="text-xs text-muted-foreground">' + (PRESET ? L('Pick colour & scent', 'اختاري اللون والعطر') : L('Pick type, colour, scent', 'اختاري النوع واللون والعطر')) + '</div>') +
        '</div></div><div class="flex items-center gap-2">' +
        ((!open && !done) ? '<span class="rounded-full bg-primary px-2 py-1 text-xs font-semibold text-primary-foreground">' + L('Choose', 'اختاري') + '</span>' : '') +
        (open ? CHEV_UP : CHEV_DOWN) + '</div></button>';

      if (open) {
        html += '<div class="space-y-5 border-t border-border p-4">';
        // Type — hidden for preset packages (the charm type is fixed)
        if (!PRESET) {
          html += '<div><div class="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">' + L('Type', 'النوع') + '</div><div class="grid grid-cols-3 gap-2">';
          SOURCES.forEach(function (s) {
            var on = slot.handle === s.handle;
            var thumb = thumbForSource(s);
            html += '<button type="button" data-pkg-type="' + esc(s.handle) + '" class="flex flex-col items-center gap-1 rounded-xl border-2 p-2 transition ' + (on ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/40') + '">' +
              (thumb ? '<img src="' + esc(thumb) + '" alt="" class="h-12 w-12 rounded-lg object-cover">' : '') +
              '<span class="text-xs font-medium">' + esc(isAr ? typeName(s.handle).ar : typeName(s.handle).en) + '</span></button>';
          });
          html += '</div></div>';
        }
        // Colour — image swatches
        if (src) {
          html += '<div><div class="mb-2 flex items-center justify-between"><span class="text-xs font-semibold uppercase tracking-wide text-muted-foreground">' + L('Colour', 'اللون') + '</span>' +
            (col ? '<span class="text-xs text-muted-foreground">' + esc(isAr ? colorAr(col.name) : col.name) + '</span>' : '') + '</div><div class="flex flex-wrap gap-2">';
          src.colors.forEach(function (c) {
            var on = slot.color === c.name;
            var cName = isAr ? colorAr(c.name) : c.name;
            var chex = colorHex(c.name) || c.hex;
            html += '<button type="button" data-pkg-color="' + esc(c.name) + '" aria-label="' + esc(cName) + '" title="' + (c.oos ? esc(L('Coming soon', 'قريباً')) : esc(cName)) + '"' + (c.oos ? ' disabled' : '') +
              ' class="relative grid h-11 w-11 place-items-center overflow-hidden rounded-full border-2 bg-muted transition ' + (on ? 'border-primary scale-110 ring-2 ring-primary/30' : 'border-border') + (c.oos ? ' opacity-40 grayscale cursor-not-allowed' : '') + '" style="' + (c.image ? "background-image:url(" + esc(c.image) + ");background-size:cover;background-position:center" : 'background:' + esc(chex)) + '">' +
              (on ? '<span class="relative z-10 grid h-5 w-5 place-items-center rounded-full bg-primary text-primary-foreground shadow">' + CHECK + '</span>' : '') + '</button>';
          });
          html += '</div></div>';
        }
        // Scent
        var hasColor = !!col;
        html += '<div><div class="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">' + L('Choose a scent', 'اختاري العطر') + '</div>';
        html += '<p data-pkg-scent-hint class="mb-2 hidden text-xs font-semibold text-rose-deep">' + esc(L('Choose your colour first 🎨', 'اختاري اللون أولاً 🎨')) + '</p>';
        html += '<div class="grid grid-cols-2 gap-2 sm:grid-cols-4">';
        SCENTS.forEach(function (s) {
          var on = slot.scent === s.id;
          var unavailable = false;
          if (hasColor && !(src && src.hasScent === false)) { var variant = findVariant(src, col.name, isAr ? s.ar : s.en); unavailable = !variant || !variant.available; }
          var cls = 'relative grid min-h-11 place-items-center rounded-xl border-2 px-2 py-3 text-xs font-medium transition ';
          if (on) { cls += 'border-primary bg-primary/10 text-primary'; }
          else if (unavailable) { cls += 'border-border opacity-40 cursor-not-allowed line-through'; }
          else { cls += 'border-border hover:border-primary/40'; }
          var best = s.id === 'miss-coco' && !unavailable;
          var badge = best ? '<span aria-hidden="true" style="position:absolute;top:-7px;left:50%;transform:translateX(-50%);white-space:nowrap;background:#f5b833;color:#4a2c17;font-size:8.5px;line-height:1.2;font-weight:800;letter-spacing:.02em;padding:2px 7px;border-radius:999px;box-shadow:0 1px 3px rgba(20,20,45,.22);z-index:2">★ ' + (isAr ? 'الأكثر مبيعاً' : 'Best Seller') + '</span>' : '';
          html += '<button type="button" data-pkg-scent="' + s.id + '"' + (hasColor ? '' : ' data-needs-color="1"') + (unavailable ? ' disabled' : '') + (best ? ' style="position:relative"' : '') + ' class="' + cls + '">' + badge + esc(isAr ? s.ar : s.en) + '</button>';
        });
        html += '</div></div></div>';
      }
      html += '</div>';
    });

    // Price + CTAs
    var dis = !isComplete();
    html += '<div class="mt-5 flex items-baseline justify-center gap-2 font-semibold text-primary"><span class="text-lg">' + esc(money(PKG.price)) + '</span>' +
      (PKG.compareAt && PKG.compareAt > PKG.price ? '<span class="text-sm font-normal text-muted-foreground line-through">' + esc(money(PKG.compareAt)) + '</span><span class="rounded-full bg-rose-deep px-2 py-1 text-xs font-bold text-white">-' + Math.round((PKG.compareAt - PKG.price) / PKG.compareAt * 100) + '%</span>' : '') + '</div>';
    html += '<div class="mt-3 flex flex-col gap-2">' +
      '<button type="button" data-pkg-buy' + (dis ? ' disabled' : '') + ' class="w-full rounded-2xl bg-primary py-4 text-base font-semibold text-primary-foreground transition hover:bg-primary/90 disabled:opacity-50">' + (dis ? L('Complete your choices', 'أكملي اختياراتكِ') : L('Buy it now', 'اشترِ الآن') + ' · ' + esc(money(PKG.price))) + '</button>' +
      '<button type="button" data-pkg-add' + (dis ? ' disabled' : '') + ' class="w-full rounded-2xl border-2 border-primary bg-card py-4 text-base font-semibold text-primary transition hover:bg-primary/10 disabled:opacity-50">' + L('Add to Cart', 'أضف إلى السلة') + '</button>' +
      '</div>';

    controls.innerHTML = html;
  }

  function flashScentHint(btn) {
    var slotEl = btn.closest('[data-pkg-controls], div');
    var hint = controls.querySelector('[data-pkg-scent-hint]');
    if (!hint) return;
    hint.classList.remove('hidden');
    clearTimeout(hint.__t);
    hint.__t = setTimeout(function () { hint.classList.add('hidden'); }, 2800);
  }

  function buildLine() {
    var slots = [];
    for (var i = 0; i < state.slots.length; i++) {
      var s = state.slots[i];
      var src = sourceByHandle(s.handle), col = colorIn(src, s.color), sc = scentById(s.scent);
      var variant = findVariant(src, col.name, (src.hasScent === false) ? null : (isAr ? sc.ar : sc.en));
      if (!variant) { err(L("That combination isn't available", 'هذه التركيبة غير متوفرة حالياً')); return null; }
      var tn = typeName(src.handle);
      slots.push({ typeEn: tn.en, typeAr: tn.ar, colorEn: colorEnOf(col.name), colorAr: colorAr(col.name), scentEn: sc.en, scentAr: sc.ar, image: (col.image || src.images[0] || ''), variantId: variant.id });
    }
    var extra = {};
    if (PKG.includeCase && state.model) extra[L('Phone', 'الجوال')] = state.model;
    var incl = [];
    if (PKG.includeCase) incl.push(L('Croc case', 'كفر الكروك'));
    if (PKG.includeMirror) incl.push(L('Phone Mirror', 'مرآة الجوال'));
    if (incl.length) extra[L('Includes', 'يشمل')] = incl.join(' + ');
    return {
      tierVariantId: PKG.variantId,
      bundleLabelEn: PKG.nameEn, bundleLabelAr: PKG.nameAr,
      totalPrice: PKG.price,
      nameEn: PKG.nameEn, nameAr: PKG.nameAr,
      image: slots[0] ? slots[0].image : '',
      slots: slots,
      extraProps: extra
    };
  }

  controls.addEventListener('click', function (e) {
    var m = e.target.closest('[data-pkg-model]');
    if (m) { state.model = m.getAttribute('data-pkg-model'); render(); return; }
    var tg = e.target.closest('[data-pkg-toggle]');
    if (tg) { var ti = parseInt(tg.getAttribute('data-pkg-toggle'), 10); state.active = (state.active === ti ? -1 : ti); render(); return; }
    var ty = e.target.closest('[data-pkg-type]');
    if (ty) { var s0 = state.slots[state.active]; if (!s0) return; s0.handle = ty.getAttribute('data-pkg-type'); s0.color = ''; s0.scent = ''; render(); return; }
    var cc = e.target.closest('[data-pkg-color]');
    if (cc && !cc.disabled) {
      var slot = state.slots[state.active]; if (!slot) return;
      slot.color = cc.getAttribute('data-pkg-color');
      var src = sourceByHandle(slot.handle);
      if (src && src.hasScent !== false) {
        var curScent = scentById(slot.scent), col = colorIn(src, slot.color);
        var v = (col && curScent) ? findVariant(src, col.name, isAr ? curScent.ar : curScent.en) : null;
        if (!v || !v.available) slot.scent = '';
      }
      render(); return;
    }
    var ss = e.target.closest('[data-pkg-scent]');
    if (ss && !ss.disabled) {
      var sslot = state.slots[state.active]; if (!sslot) return;
      if (!sslot.color) { flashScentHint(ss); return; }
      sslot.scent = ss.getAttribute('data-pkg-scent');
      // move on to the next unfinished charm — or close the accordion once everything is done
      var next = -1;
      for (var k = 0; k < state.slots.length; k++) { if (k !== state.active && !slotDone(state.slots[k])) { next = k; break; } }
      state.active = next;
      render(); return;
    }
    var add = e.target.closest('[data-pkg-add]');
    var buy = e.target.closest('[data-pkg-buy]');
    if (add || buy) {
      if (!isComplete()) { err(L('Complete your choices', 'أكملي اختياراتكِ')); return; }
      var line = buildLine(); if (!line) return;
      if (buy) {
        var b = buy, orig = b.textContent; b.disabled = true; b.textContent = L('Loading...', 'إعداد...');
        CharmiesCart.addBundle(line, { express: true })
          .then(function (cart) { return CharmiesCart.checkout(cart); })
          .catch(function () { b.disabled = false; b.textContent = orig; err(L('Checkout failed', 'تعذر إنشاء الطلب')); });
      } else {
        CharmiesCart.addBundle(line).catch(function (ex) { err((ex && ex.data && ex.data.description) || L('Sorry — could not add to cart. Please try again.', 'عذراً، تعذّرت الإضافة إلى السلة. حاولي مرة أخرى.')); });
      }
    }
  });

  // Un-stick a frozen express button if restored from bfcache after pressing Back.
  window.addEventListener('pageshow', function (e) { if (e.persisted) render(); });

  render();
})();
